import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_RUPTURE_REQUEST,
  FETCH_RUPTURE_SUCCESS,
  FETCH_RUPTURE_ERROR,
} from 'actionTypes'

/*
 * REQUEST RUPTURES
 */
export const fetchRuptures = (auth, filters, signal = null) => (dispatch) => {
  dispatch(fetchRupturesRequest())

  if (!filters || (!filters.idBranch && !filters.allBranches)) {
    filters = {
      ...filters,
      idBranch: auth.user.locationCode,
    }
  }

  const params = {
    ...filters,
  }

  // Se não houver signal, usa o spinner global (comportamento padrão)
  // Se houver signal, não usa spinner (será controlado pelo componente)
  const apiCall = new Api(auth.user.dsToken, dispatch)
    .post(API_URL.RUPTURES, params, signal)

  if (!signal) {
    return apiCall
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(fetchRupturesSuccess(response.data, params))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchRupturesError(error))
        dispatch(hideSpinner())
      })
  } else {
    return apiCall
      .then((response) => {
        dispatch(fetchRupturesSuccess(response.data, params))
      })
      .catch((error) => {
        // Não dispara erro se foi cancelado pelo usuário
        if (error.name !== 'AbortError') {
          dispatch(fetchRupturesError(error))
        }
      })
  }
}

export const fetchRupturesRequest = () => ({
  type: FETCH_RUPTURE_REQUEST,
})

export const fetchRupturesSuccess = (data, filters) => ({
  type: FETCH_RUPTURE_SUCCESS,
  payload: data,
  filters,
})

export const fetchRupturesError = (error) => ({
  type: FETCH_RUPTURE_ERROR,
  payload: error,
})
